import {
  SEARCH_TRANSFERS,
  SEARCH_TRANSFERS_FAILURE,
  SEARCH_TRANSFERS_SUCCESS,
} from '../actions'
import { AcatsSearchDto, AcatsTransfer } from '../api/types'
import { INITIAL_TRANSFER_SEARCH_STATE } from '../containers/contexts/search'
import { TransferSearchState } from '../types'

export const transfersReducer = (
  state: TransferSearchState = INITIAL_TRANSFER_SEARCH_STATE,
  action: {
    type: string
    transferResults?: AcatsTransfer[]
    errorMessage?: string
    acatsSearchDto?: AcatsSearchDto
  }
) => {
  const {
    type,
    transferResults = [],
    errorMessage,
    acatsSearchDto = {},
  } = action
  switch (type) {
    case SEARCH_TRANSFERS:
      return {
        ...INITIAL_TRANSFER_SEARCH_STATE,
        loadingResults: true,
        acatsSearchDto,
      }
    case SEARCH_TRANSFERS_SUCCESS:
      return { ...state, loadingResults: false, transferResults }
    case SEARCH_TRANSFERS_FAILURE:
      return { ...state, loadingResults: false, errorMessage }
    default:
      return state
  }
}
